<template>
  <div class="privacy-page">
    <div class="privacy-header">
      <h1>{{ $t('privacy.title') }}</h1>
      <p>{{ $t('privacy.lastUpdate') }}</p>
    </div>

    <div class="privacy-content">
      <section>
        <h2>{{ $t('privacy.overview') }}</h2>
        <p>{{ $t('privacy.overviewDesc') }}</p>
      </section>

      <section>
        <h2>{{ $t('privacy.collection') }}</h2>
        <h3>{{ $t('privacy.autoCollection') }}</h3>
        <p>{{ $t('privacy.autoCollectionDesc') }}</p>
        <ul>
          <li v-for="(item, index) in $t('privacy.autoCollectionItems')" :key="'auto-' + index">{{ item }}</li>
        </ul>

        <h3>{{ $t('privacy.userProvided') }}</h3>
        <p>{{ $t('privacy.userProvidedDesc') }}</p>
        <ul>
          <li v-for="(item, index) in $t('privacy.userProvidedItems')" :key="'user-' + index">{{ item }}</li>
        </ul>
        <p><strong>{{ $t('privacy.dataControl') }}</strong></p>
      </section>

      <section>
        <h2>{{ $t('privacy.cookies') }}</h2>
        <p>{{ $t('privacy.cookiesDesc') }}</p>
        
        <h3>{{ $t('privacy.googleAnalytics') }}</h3>
        <p>{{ $t('privacy.googleAnalyticsDesc') }} <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener">{{ $t('privacy.gaOptout') }}</a>。</p>
        
        <h3>{{ $t('privacy.localStorage') }}</h3>
        <p>{{ $t('privacy.localStorageDesc') }}</p>
      </section>

      <section>
        <h2>{{ $t('privacy.advertising') }}</h2>
        <p>{{ $t('privacy.advertisingDesc') }} <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener">{{ $t('privacy.adSettings') }}</a> {{ $t('privacy.adSettingsLink') }}</p>
      </section>

      <section>
        <h2>{{ $t('privacy.sharing') }}</h2>
        <p>{{ $t('privacy.sharingDesc') }}</p>
        <ul>
          <li v-for="(item, index) in $t('privacy.sharingItems')" :key="'share-' + index">{{ item }}</li>
        </ul>
      </section>

      <section>
        <h2>{{ $t('privacy.security') }}</h2>
        <p>{{ $t('privacy.securityDesc') }}</p>
        <ul>
          <li v-for="(item, index) in $t('privacy.securityItems')" :key="'sec-' + index">{{ item }}</li>
        </ul>
      </section>

      <section>
        <h2>{{ $t('privacy.children') }}</h2>
        <p>{{ $t('privacy.childrenDesc') }}</p>
      </section>

      <section>
        <h2>{{ $t('privacy.rights') }}</h2>
        <p>{{ $t('privacy.rightsDesc') }}</p>
        <ul>
          <li v-for="(item, index) in $t('privacy.rightsItems')" :key="'right-' + index">{{ item }}</li>
        </ul>
      </section>

      <section>
        <h2>{{ $t('privacy.updates') }}</h2>
        <p>{{ $t('privacy.updatesDesc') }}</p>
      </section>

      <section>
        <h2>{{ $t('privacy.contact') }}</h2>
        <p>{{ $t('privacy.contactDesc') }}</p>
        <ul>
          <li>{{ $t('about.website') }}：<a href="https://ysgjw.com">ysgjw.com</a></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-page {
  max-width: 800px;
  margin: 0 auto;
}

.privacy-header {
  text-align: center;
  margin-bottom: 40px;
}

.privacy-header h1 {
  font-size: 36px;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.privacy-header p {
  color: var(--text-secondary);
  font-size: 14px;
}

.privacy-content {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 40px;
  box-shadow: var(--shadow-md);
}

section {
  margin-bottom: 32px;
}

section:last-child {
  margin-bottom: 0;
}

h2 {
  font-size: 22px;
  color: var(--text-primary);
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--accent-color);
}

h3 {
  font-size: 16px;
  color: var(--text-primary);
  margin: 16px 0 8px;
}

p {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 12px;
}

ul {
  padding-left: 24px;
  margin-bottom: 12px;
}

li {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 4px;
}

a {
  color: var(--accent-color);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

strong {
  color: var(--text-primary);
}

@media (max-width: 768px) {
  .privacy-content {
    padding: 24px;
  }

  .privacy-header h1 {
    font-size: 28px;
  }

  h2 {
    font-size: 18px;
  }
}
</style>
